export default "__VITE_ASSET__f218d0d5__"